<template>
    <div class="row">
        <div class="col-sm-12 pt-4" style="border-bottom: 1px solid rgba(0,0,0,0.1);">
            <div class="col-sm-12 mb-4 text-bold font-weight-700 text-capitalize text-muted" v-text="dayname"></div>
            <div class="col-sm-12 mb-4">
                <div v-for="(timeSlot, key) in schedule" :key="key" class="row">
                    <div class="col-4 text-bold font-weight-700 text-capitalize pb-2 operation-text" v-text="getDisplyedAvailability(timeSlot)"></div>
                    <div class="col-8 font-weight-700 text-uppercase pb-2 operation-text" v-text="getDisplyedTime(timeSlot)"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";

export default {
    name: "OperationItem",
    
    computed: {
        dayname() {
            return this.schedule && this.schedule.length > 0 ? this.schedule[0].dayname : "";
        }
    },

    methods: {
        getDisplyedAvailability(timeSlot) {
            return timeSlot.is_available ? "open" : "closed";
        },
        getDisplyedTime(timeSlot) {
            console.log(moment(timeSlot.start));
            let start = moment(timeSlot.start).add(timeSlot.timezone, "hours").format("hh:mm A");
            let end = moment(timeSlot.end).add(timeSlot.timezone, "hours").format("hh:mm A").replace("12:00 AM", "12:00 MN");

            return `${ start } - ${ end }`;
        },
    },

    props: {
        schedule: Array,
    },
}
</script>
<style lang="css" scoped>
    .operation-text {
        font-size: 16px;
    }
</style>